import React from 'react'
import Manager from '../../public/components/Manager'
import MonthlySalaryApplyDetail from './MonthlySalaryApplyDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        // { _text: '发放月份', field: 'Issue', minWidth: 250, search: true, },
        // { _date: '薪资所得给付日', field: 'SalaryPaymentDate', minWidth: 150, filter: true, align: 'right'},
        // { _float: '应发总额', minWidth: 150, flex: 10, filter: true },
        // { _float: '实发总额', minWidth: 150, flex: 10, filter: true },
        // { _float: '住房公积金', minWidth: 150, filter: true, },
        // { _float: '社保个人扣款', minWidth: 150, filter: true, },
        // { _float: '所得税', minWidth: 150, filter: true, },
        // { _int: '人数', minWidth: 150, filter: true, },
        // { _text: '状态', field: 'Archives.StatusName', minWidth: 150, search: true,filter:['select'], },
        { _text: '发放月份', field: 'Issue', minWidth: 150, search: true, },
        //{ _date: '薪资所得给付日', field: 'SalaryPaymentDate', minWidth: 150, filter: true, align: 'right'},
        { _float: '应发总额', minWidth: 135, flex: 10, filter: true },
        { _float: '实发总额', minWidth: 135, flex: 10, filter: true },
        { _float: '应税加班', field: '_TaxableWorkOvertime', minWidth: 135, flex: 10, filter: true},
        { _float: '生日礼金', field: '_BirthdayGift', minWidth: 135, flex: 10, filter: true},
        { _float: '餐费补助', field: '_MealAllowance', minWidth: 135, flex: 10, filter: true},
        { _float: '高温补贴', field: '_HighTemperatureAllowance', minWidth: 135, flex: 10, filter: true},
        { _float: '季度奖金', field: '_QuarterlyBonus', minWidth: 135, flex: 10, filter: true},
        { _float: '其他税前(+)', field: '_OtherPreTaxItems', minWidth: 135, flex: 10, filter: true},
        { _float: '其他税前(-)', field: '_OtherPreTaxDeductions', minWidth: 135, flex: 10, filter: true},
        { _float: '请假扣款', field: '_AskForLeaveDeductions', minWidth: 135, flex: 10, filter: true},
        { _float: '所得税', minWidth: 135, filter: true, },
        { _float: '代扣话费', field: '_WithholdingMoney', minWidth: 135, flex: 10, filter: true},
        { _float: '代扣班车费', field: '_BusFaresAreDeducted', minWidth: 135, flex: 10, filter: true},
        { _float: '代扣餐费', field: '_WithholdingMeals', minWidth: 135, flex: 10, filter: true},
        { _float: '其他税后(-)', field: '_OtherAfterTaxDeductions', minWidth: 135, flex: 10, filter: true},
        { _float: '其他税后(+)', field: '_OtherAfterTaxItems', minWidth: 135, flex: 10, filter: true},
        { _float: '住房津贴', field: '_HousingAllowance', minWidth: 135, flex: 10, filter: true},
        { _int: '人数', minWidth: 135, filter: true, },
        { _text: '状态', field: 'Archives.StatusName', minWidth: 135, search: true,filter:['select'],},
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <MonthlySalaryApplyDetail {...props} id={data.id} readOnly={true} />)
    }
}

export default props => <Manager {...props} config={config} />